import React from "react";

interface LogoProps {
  className?: string;
}

export const Logo: React.FC<LogoProps> = ({ className }) => {
  return (
    <div className={className}>
      <h2 className="text-xl font-bold">S&S ACADEMY</h2>
    </div>
  );
};
